// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3gVR2","footer":"ModalCreateQualiphyProcedure_footer__1Fo-r","additionData":"ModalCreateQualiphyProcedure_additionData__yaZSM"};